var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-area",style:({width:(_vm.width <= 90 ? 60 : _vm.width) + 'px'})},[_c('XHandle',{on:{"widthChange":_vm.widthChange}}),_vm._v(" "),_c('div',{staticClass:"right-inner"},[_c('div',{staticClass:"top-area"},[_vm._t("top")],2),_vm._v(" "),_c('BottomArea',[_vm._t("bottom")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74dbd73b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/RightArea.vue
// module id = 292
// module chunks = 0